// const def_prompt = `The following is a transcript of an interview dialogue. Please extract the last question asked by the interviewer and provide an answer. If it is an algorithm question, please provide the approach and code implementation. If no question is found, there is no need to respond.`

const DEFAULT_SYSTEM_PROMPT = `The following is a transcript of an interview dialogue. Please extract the last question asked by the interviewer and provide an answer. If it is an algorithm question, please provide the approach and code implementation. If no question is found, there is no need to respond.

Please provide a concise summary of the question and answer in the first sentence.

First sentence should be like this:

Q: The last question asked by the interviewer
A: The answer to the last question

Then provide the detailed answer.

Answer in transcript language.
`
const DEFAULT_MODEL = "google/gemini-2.0-flash-lite-preview-02-05:free"
const DEFAULT_API_PROVIDER = "openrouter"
const DEFAULT_API_BASE_URL = "https://openrouter.ai/api/v1"

function gpt_system_prompt(useDefault = false) {
    return useDefault ? DEFAULT_SYSTEM_PROMPT : (localStorage.getItem("gpt_system_prompt") || DEFAULT_SYSTEM_PROMPT)
}

function azure_language(useDefault = false) {
    return useDefault ? "en-US" : (localStorage.getItem("azure_language") || "en-US")
}

function azure_region(useDefault = false) {
    return useDefault ? "eastasia" : (localStorage.getItem("azure_region") || "eastasia")
}

function gpt_model(useDefault = false) {
    return useDefault ? DEFAULT_MODEL : (localStorage.getItem("gpt_model") || DEFAULT_MODEL)
}

function api_provider(useDefault = false) {
    return useDefault ? DEFAULT_API_PROVIDER : (localStorage.getItem("api_provider") || DEFAULT_API_PROVIDER)
}

function api_base_url(useDefault = false) {
    if (useDefault) return DEFAULT_API_BASE_URL;
    
    const savedUrl = localStorage.getItem("api_base_url");
    if (savedUrl) return savedUrl;
    
    // 如果没有保存的URL，根据当前提供商返回默认值
    const provider = api_provider();
    switch(provider) {
        case 'openrouter':
            return "https://openrouter.ai/api/v1";
        case 'openai':
            return "https://api.openai.com/v1";
        default:
            return "";
    }
}

export default {
    gpt_system_prompt,
    azure_language,
    azure_region,
    gpt_model,
    api_provider,
    api_base_url
}